import { render, staticRenderFns } from "./BookmarkIcon.vue?vue&type=template&id=4fd6d5da&scoped=true&"
import script from "./BookmarkIcon.vue?vue&type=script&lang=js&"
export * from "./BookmarkIcon.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkIcon.vue?vue&type=style&index=0&id=4fd6d5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd6d5da",
  null
  
)

export default component.exports